<template>
  <div class="MobileTicketTaskForm">
    <template v-for="e in ticketTaskFormData">
      <template v-if="'allow_deny'==e.type" />

      <!-- 特殊表单表单,展示为两个按钮 -->
      <div v-else :key="e.id">
        <div>{{e.name}}</div>
 
        <TicketTaskFormItem
          ref="ticketTaskFormItem"
          :item="e"
          v-model="properties"
          :mode="mode" />
      </div>
    </template>
  </div>
</template>

<script>
import AbstractTicketTaskForm from "@/assets/mixins/AbstractTicketTaskForm";

export default {
  name: "MobileTicketTaskForm",

  mixins: [AbstractTicketTaskForm],

  props: ["taskId", "fullScreen"],

  watch: {
    taskId() {
      this.listForm();
    }
  },

  mounted() {
    this.listForm();
  }
};
</script>

<style>
  @import '../../assets/style/ticket_form_item.css';

  .MobileTicketTaskForm .el-select {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketTaskForm.vue